<script lang="ts">
  import { user } from '../stores/user';
  import Button from './Button.svelte';
  import { getFunctions, httpsCallable } from 'firebase/functions';

  interface Props {
    location: 'footer' | 'sidebar';
  }

  let { location }: Props = $props();

  const functions = getFunctions();

  const confirm = httpsCallable(functions, 'newConfirmShare');
  let disabled = $state(false);

  async function handleConfirm() {
    disabled = true;
    const { data } = await confirm();
    if (data === 'done') {
      disabled = false;
    }
  }
</script>

{#if $user && $user.sharedEmail && !$user.verified}
  <div class={`confirm ${location}`}>
    <p><strong>{$user?.sharedEmail}</strong> wants to share a menu with you</p>
    <Button
      size="small"
      backgroundColor="white"
      textColor="black"
      {disabled}
      loading={disabled}
      onClick={handleConfirm}>Confirm</Button
    >
    <Button {disabled} size="small" backgroundColor="black" textColor="white"
      >Reject</Button
    >
  </div>
{/if}

<style>
  .confirm {
    display: flex;
    align-items: center;
    gap: 1ch;
    border: 1px solid white;
    padding: 0.2rem 0.5rem;
    border-radius: 4px;
  }

  .confirm.sidebar {
    flex-direction: column;
  }

  .confirm.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 1ch;
    background-color: var(--primary);
  }

  p {
    margin: 0;
    color: var(--primaryText);
  }

  @media screen and (max-width: 768px) {
    .sidebar {
      display: none;
    }
    .footer {
      display: block;
      padding: 2rem;
      margin: 1rem;
      text-align: center;
      background-color: var(--altColor);
      box-shadow: 0 5px 10px #0000005a;
    }
    .footer p {
      margin-bottom: 1ch;
    }
  }
</style>
